export const removeStationFromStopName = (
  stopName: string | undefined | null,
) => stopName?.replace(/\s+st(\s|\(|$)/, "$1") ?? "";
